// Dev-only console logger. Silences non-critical warnings in production so
// the browser console stays clean for real users, while preserving useful
// diagnostics during development.
const IS_DEV =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export function devWarn(...args) {
  if (IS_DEV) console.warn(...args);
}
export function devError(...args) {
  if (IS_DEV) console.error(...args);
}
